export const NON_DIGITS_REGEX = /([^\d+])/g;

const USA_PREFIX = '(\\+?1)?';
const COUNTRY_CODE_OR_START_OF_FIRST_THREE_DIGITS = '([2-9]\\d{0,2})';
const FIRST_THREE_DIGITS_OR_REMAINDER_OF_FIRST_THREE_DIGITS = '(\\d{1,3})?';
const REST_OF_PHONE_NUMBER = '(\\d*)?';
export const PHONE_NUMBER_REGEX = new RegExp(
    `^${USA_PREFIX}${COUNTRY_CODE_OR_START_OF_FIRST_THREE_DIGITS}${FIRST_THREE_DIGITS_OR_REMAINDER_OF_FIRST_THREE_DIGITS}${REST_OF_PHONE_NUMBER}$`
);

/**
 * Strips all non-digit characters from a phone number string.
 * This is useful for sending phone numbers to APIs that expect only digits.
 *
 * @param input The phone number string to strip
 * @returns A string containing only digits
 */
export const stripPhoneNumberFormatting = (input?: string | null): string => {
    /* istanbul ignore next */
    if (!input) return '';

    // Remove all non-digit characters
    return input.replace(/\D/g, '');
};

/**
 * Converts a string into a phone number, preferring x (xxx) xxx-xxxx, but supporting (xxx) xxx-xxxx or xxx-xxxx as well
 * @param input string to convert into a phone number in the formats above
 * @returns a string representation of a phone number
 */
export const formatPhoneNumber = (input: string): string => {
    if (!input) return '';

    // Clean the input - remove all non-digit characters except +
    let digits = input.replace(/[^\d+]/g, '');

    // Remove country code if present
    if (digits.startsWith('+1')) {
        digits = digits.substring(2);
    } else if (digits.startsWith('1') && digits.length > 10) {
        digits = digits.substring(1);
    }

    // Format the phone number
    if (digits.length <= 3) {
        return `(${digits}`;
    } else if (digits.length <= 6) {
        return `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
    } else {
        return `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6, 10)}`;
    }
};
